import React from 'react';
import './Category.css';

import { renderIcon } from '../../utils';

import { Link } from 'react-router-dom';



const Category = (props) => {

    const { index, category, count, image } = props;

    return (
        <div key={category} className={`category-item category-${index}`}>

            <img src={image} alt={category} /> {/* Category Image */}

            <div className="content">
                <div className="icon">{renderIcon(category)}</div> {/* Render category-specific icon */}
                <div className="text">
                    <Link to={`/Vendors/Search/${encodeURIComponent(category)}`}>{category}</Link> {/* Link to the search page filtered by this category */}
                    <p>{count} Vendors</p>
                </div>
            </div>

        </div>
    );
};

export default Category;